import { CheckCircle2 } from "lucide-react";
import { type FormEvent, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "../lib/api";

export function ActivatePage() {
  const navigate = useNavigate();
  const query = useMemo(() => new URLSearchParams(window.location.search), []);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (password !== confirm) {
      setError("Les deux mots de passe ne correspondent pas.");
      return;
    }
    setError("");
    try {
      await api.post(
        "/api/v1/enterprises/activate/",
        { uid: query.get("uid"), token: query.get("token"), password },
        null
      );
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Activation impossible.");
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-slate-950 p-5">
      <div className="w-full max-w-md rounded-2xl bg-white p-7 shadow-2xl">
        {done ? (
          <div className="text-center">
            <CheckCircle2 className="mx-auto text-emerald-600" size={42} />
            <h1 className="mt-4 text-2xl font-black">Accès activé</h1>
            <p className="mt-2 text-sm text-slate-500">Votre mot de passe est défini. Vous pouvez maintenant vous connecter.</p>
            <button className="btn-primary mt-6 w-full" onClick={() => navigate("/")}>Aller à la connexion</button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-emerald-600">SahelTech Platform</div>
            <h1 className="mt-2 text-2xl font-black">Activer mon accès</h1>
            <p className="mt-2 text-sm text-slate-500">Définissez un mot de passe robuste pour rejoindre votre entreprise.</p>
            <div className="mt-6 space-y-4">
              <label><span className="label">Mot de passe</span><input className="field" type="password" minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
              <label><span className="label">Confirmation</span><input className="field" type="password" minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></label>
            </div>
            {error && <div className="mt-4 rounded-xl bg-red-50 p-3 text-sm text-red-700">{error}</div>}
            <button className="btn-primary mt-6 w-full">Activer mon compte</button>
          </form>
        )}
      </div>
    </div>
  );
}
